import { render } from "./IdeaList.vue?vue&type=template&id=1df9fe47&ts=true"
import script from "./IdeaList.vue?vue&type=script&lang=ts"
export * from "./IdeaList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__